import './EInvoicePreview.css'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { MaterialSymbol } from 'react-material-symbols'

import { Button } from 'primereact/button'

import { useSplitViewContext } from '../../../../contexts/splitView'
import { PDFViewer } from './PDFViewer'

export const EInvoicePreview: React.FC = () => {
  const { t } = useTranslation()
  const { eInvoicePreviewUrl, eInvoicePreviewFileName, setActiveSplitView } =
    useSplitViewContext()

  const openEInvoiceInTab = () => window.open(eInvoicePreviewUrl, '_blank')

  const handleClose = () => {
    setActiveSplitView(null)
  }

  return (
    <aside className="aside">
      <header className="aside__header flex align-items-center pl-3">
        <h3 className="m-0 mr-auto">{eInvoicePreviewFileName}</h3>

        {/* Open preview in new tab */}
        <Button
          link
          aria-label={t(
            'eInvoiceDetails.title.openPreview.options.splitView.aside.openInTab.label',
          )}
          onClick={openEInvoiceInTab}
          icon={<MaterialSymbol icon="open_in_new" size={24} />}
        />

        {/* Close preview */}
        <Button
          link
          rounded
          aria-label={t(
            'eInvoiceDetails.title.openPreview.options.splitView.aside.close.label',
          )}
          onClick={handleClose}
          icon={<MaterialSymbol icon="close" size={24} />}
        />
      </header>

      {/* E-Invoice Preview */}
      <PDFViewer src={eInvoicePreviewUrl} />
    </aside>
  )
}
